import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import './styles.scss'

const Badge = ({ text, variant, top, right, bottom, left, connectorPosition, connectorDirection }) => (
  <div
    className={cx({
      badge: true,
      [`badge--${variant}`]: variant,
      [`with-connectorDirection--${connectorDirection}`]: connectorDirection,
      [`with-connectorPosition--${connectorPosition}`]: connectorPosition
    })}
    style={{ top: top, right: right, bottom: bottom, left: left }}
  >
    <div className="badge__text">{text}</div>
    <div className="badge__connector">
      {connectorDirection === 'top' || connectorDirection === 'bottom' ? (
        <svg width="20" height="30" viewBox="0 0 22 32">
          <path d="M20 0C20 10 16 30 0 30" />
        </svg>
      ) : (
        <svg width="30" height="20" viewBox="0 0 32 22">
          <path d="M0 21C15 21 15 1 30 1" />
        </svg>
      )}
    </div>
  </div>
)

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary']),
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number,
  connectorDirection: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  connectorPosition: PropTypes.oneOf(['left', 'right'])
}

Badge.defaultProps = {
  variant: 'neutral',
  top: null,
  right: null,
  bottom: null,
  left: null,
  connectorDirection: 'top',
  connectorPosition: 'left'
}

export default Badge
